import React from 'react';
import ResourceComponent from '../../common/ResourceComponent';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import * as actions from './EmbeddableApi';
import {connect} from 'react-redux';
import {colorBlockFormatter, dollarsFormatter, impactFormatter, percentage} from '../../common/TableFormatters';
import {Badge, Button, Col, Row} from 'reactstrap';
import defaultImage from './utils/no_image.png';
import ShareButton from './utils/ShareButton';
import {getMaterialImageAlt} from '../../common/Utils';

class EmbLumberItem extends ResourceComponent {

    state = {
        showTooltip: false,
        imagesStatus: {},
    };

    copyToClipboard = (id) => {
        const temp = document.createElement('textarea');
        document.body.appendChild(temp);
        temp.value = `https://${location.hostname}/lumbers?item_id=${id}`;
        temp.select();
        document.execCommand('copy');
        this.setState({showTooltip: id},
            () => setTimeout(
                () => this.setState({showTooltip: false}), 3000),
        );
    };

    render() {
        const {showTooltip, imagesStatus, filter} = this.state;
        const {
            settings, card_detail, lumber, index, ecommerceConnected, checkClaimed, onUnclaim, onClaim,
            onLumberClick, claimEnabled, sendEventData,
        } = this.props;

        return (
            <Col key={lumber.id}
                 className={`mt-4 pointer align-content-center item-container ${index === 0 ? 'first-slab-item-margin ' : ' '}
                 ${filter ? 'col-12 col-sm-12 col-md-6 col-lg-4' : 'col-12 col-sm-6 col-md-4 col-lg-3'}
                 `}
                 onClick={() => {
                     onLumberClick(lumber.id);
                     sendEventData('view_item', {
                         currency: 'USD',
                         value: lumber.price,
                         items: [{
                             item_name: `Lumber: ${lumber.number}`,
                             price: lumber.price,
                         }],
                     });
                 }}>
                <div
                    className='item-content'
                    style={{backgroundColor: settings.card_container_color ? settings.card_container_color : null}}>
                    {card_detail.sale_discount_index && lumber.discount && lumber.price !== lumber.base_price &&
                        <div style={{position: 'relative'}}>
                            <div
                                className='discount-banner'
                                style={{
                                    position: card_detail.show_images_index ? 'absolute' : 'inherit',
                                    opacity: card_detail.banner_transparency,
                                    backgroundColor: settings.banner_color_index ? settings.banner_color_index : 'transparent',
                                    color: settings.font_color_index ? settings.font_color_index : 'black',
                                }}>
                                <span className='sale'>SALE!</span>
                                <span
                                    className='discount'>{percentage(lumber.price, lumber.price_no_discount)}</span>
                            </div>
                        </div>
                    }
                    {card_detail.show_images_index &&
                        <React.Fragment>
                            <div className='image-container'>
                                <img
                                    alt={getMaterialImageAlt(lumber, lumber.picture)}
                                    src={lumber.picture && lumber.picture.large_url ? lumber.picture.large_url : (settings.slab_default_pic_url
                                        ? settings.slab_default_pic_url
                                        : defaultImage)}
                                    onLoad={() => {
                                        imagesStatus.id = true;
                                        this.setState({imagesStatus});
                                    }}
                                />
                            </div>
                        </React.Fragment>
                    }

                    <div className='body'>
                        <div className='item-data border-top'>
                            <Row className='m-2'>
                                {card_detail.tree_name_index &&
                                    <Col xs={12}
                                         className='d-flex justify-content-center pl-0 pr-0 mr-0'>
                                    <span className='h5'>
                                        {settings.show_color_block ? colorBlockFormatter(lumber.name, lumber.color) : lumber.name}
                                    </span>
                                    </Col>
                                }
                                {card_detail.number_index &&
                                    <Col xs={12}
                                         className={'d-flex justify-content-center pl-0 pr-0'}>
                                        <Badge
                                            className={'float-right custom-badge'}
                                            color='light'>
                                            <b>{lumber.number}</b>
                                        </Badge>
                                    </Col>
                                }
                            </Row>
                            <div className='pt-2 pb-2 pl-2 pr-2 border-top'>
                                {card_detail.source_type_index &&
                                    <Row>
                                        <Col xs={5} className='pr-0 mr-0'>
                                            <small>Source Type:</small>
                                        </Col>
                                        <Col xs={7} className='pl-1 text-right'>
                                            <b className='h5'>{lumber.source_type}</b>
                                        </Col>
                                    </Row>
                                }

                                {card_detail.location_index &&
                                    <Row>
                                        <Col xs={4} className='pr-0 mr-0'>
                                            <small>Location:</small>
                                        </Col>
                                        <Col xs={8} className='pl-1 text-right'>
                                            <b className='h5'>{lumber.location}</b>
                                        </Col>
                                    </Row>
                                }
                                <React.Fragment>
                                    {card_detail.length_index &&
                                        <Row>
                                            <Col xs={8} className='pr-0 mr-0'>
                                                <small>Length:</small>
                                            </Col>
                                            <Col xs={4} className='pl-1 text-right'>
                                                <b className='h5'>{lumber.length}{'"'}</b>
                                            </Col>
                                        </Row>
                                    }
                                </React.Fragment>
                                <React.Fragment>
                                    {card_detail.min_width_index &&
                                        <Row>
                                            <Col xs={8} className='pr-0 mr-0'>
                                                <small>Width:</small>
                                            </Col>
                                            <Col xs={4} className='pl-1 text-right'>
                                                <b className='h5'>{lumber.width}{'"'}</b>
                                            </Col>
                                        </Row>
                                    }
                                </React.Fragment>
                                {card_detail.thickness_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>Thickness:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{lumber.thick}{'"'}</b>
                                        </Col>
                                    </Row>
                                }
                                {card_detail.surfaced_thickness_index}
                                {card_detail.surfaced_thickness_index &&
                                    <Row>
                                        <Col xs={9} className='pr-0 mr-0'>
                                            <small>Surfaced Thickness:</small>
                                        </Col>
                                        <Col xs={3} className='pl-1 text-right'>
                                            <b className='h5'>{lumber.surfaced_thickness}{'"'}</b>
                                        </Col>
                                    </Row>
                                }
                                {card_detail.board_feet_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>Board feet:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{lumber.total_bf}</b>
                                        </Col>
                                    </Row>
                                }
                                {card_detail.bf_price_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>BF price:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{dollarsFormatter(lumber.bf_price)}</b>
                                        </Col>
                                    </Row>
                                }
                                {settings.show_carbon_impact &&
                                    <Row>
                                        <Col xs={6} className='pr-0 mr-0'>
                                            <small>Carbon Impact:</small>
                                        </Col>
                                        <Col xs={6} className='pl-1 text-right'>
                                            <b className='h5'>{impactFormatter(lumber.carbon_impact_mt)}</b>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    {card_detail.share_button_index &&
                                        <ShareButton item={lumber} showTooltip={showTooltip}
                                                     copyToClipboard={this.copyToClipboard} />
                                    }
                                </Row>
                            </div>
                        </div>
                        {((claimEnabled || (ecommerceConnected)) || card_detail.price_index) &&
                            <Row className='m-0 item-summary p-3 pt-0 border-top align-self-end'>
                                {card_detail.price_index &&
                                    <Col xs={12}
                                         className='d-inline-block p-1 text-right d-flex justify-content-center'>
                                        {card_detail.discount_label_index && lumber.discount && lumber.price !== lumber.base_price ?
                                            <div className='discount-price'>
                                                <h3 style={{fontSize: card_detail.discount_font_size_index}}
                                                    className='discounted-price'>{lumber.price ? dollarsFormatter(lumber.price) : ''}
                                                </h3>
                                                <h4 style={{fontSize: card_detail.price_font_size_index}}
                                                    className='base_price'>
                                                    {lumber.price ? dollarsFormatter(lumber.price_no_discount) : ''}
                                                </h4>
                                            </div> :
                                            <h3 style={{fontSize: card_detail.price_font_size_index}}
                                                className='m-0'>{lumber.price ? dollarsFormatter(lumber.price) : ''}
                                            </h3>
                                        }
                                    </Col>
                                }
                                {(claimEnabled || (!claimEnabled && ecommerceConnected)) && lumber.for_sale &&
                                    <Col
                                        className='p-1 m-0 d-flex justify-content-center'>
                                        {checkClaimed(lumber)
                                            ? <Button size='sm' color='info'
                                                      onClick={(e) => {
                                                          e.stopPropagation();
                                                          onUnclaim(lumber);
                                                      }}>
                                                {claimEnabled ? 'ON HOLD' : 'In cart'}
                                            </Button>
                                            : <Button size='sm' color='danger'
                                                      onClick={(e) => {
                                                          e.stopPropagation();
                                                          onClaim(lumber);
                                                      }}>
                                                {claimEnabled ? 'Claim Item' : 'Add to Cart'}
                                            </Button>
                                        }
                                    </Col>
                                }
                            </Row>}
                    </div>
                </div>
            </Col>
        );
    }
}

EmbLumberItem.contextTypes = {
    router: PropTypes.object,
};

EmbLumberItem.propTypes = {
    actions: PropTypes.object,
    history: PropTypes.object,
};

const mapStateToProps = ({appState}) => ({
    profile: appState.profile,
    claimedItems: appState.claimedItems,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        actions,
        dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EmbLumberItem);


// WEBPACK FOOTER //
// ./src/containers/embeddable/EmbLumberItem.js